/**
 * Runtime knobs for Google Analytics 4.
 * Measurement ID must match the gtag snippet in index.html.
 *
 * Override without a code change:
 *   VITE_GA_MEASUREMENT_ID=G-XXXX
 *   VITE_GA_DEBUG=1
 *   ?gaDebug=1
 */
export const GA_CONFIG = {
  measurementId:
    (typeof import.meta.env.VITE_GA_MEASUREMENT_ID === 'string' &&
      import.meta.env.VITE_GA_MEASUREMENT_ID.trim()) ||
    'G-43Y1MMFFSY',
  appName: 'playgrid',
  /** Master switch — false drops every event. */
  enabled: true,
  /**
   * Log events to the console. Also on with ?gaDebug=1.
   * Does not stop sending to GA.
   */
  debug: import.meta.env.VITE_GA_DEBUG === '1',
} as const;

export function isGaDebugEnabled(): boolean {
  if (GA_CONFIG.debug) return true;
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('gaDebug') === '1';
}
